import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

interface BottomNavItemProps {
  to?: string;
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  'aria-label'?: string;
}

const BottomNavItem = ({ 
  to, 
  icon, 
  label, 
  isActive = false, 
  onClick,
  'aria-label': ariaLabel 
}: BottomNavItemProps) => {
  const location = useLocation();
  
  // Определяем активное состояние
  const active = isActive || (to && location.pathname === to);
  
  const baseClasses = `
    flex flex-col items-center justify-center px-1 py-2 
    transition-colors duration-200 rounded-lg min-h-[48px] flex-1
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
  `;
  
  const activeClasses = active 
    ? "text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-950/30" 
    : "text-muted-foreground hover:text-foreground hover:bg-muted";

  const content = (
    <>
      <div className="w-6 h-6 mb-1">
        {icon}
      </div>
      <span className="text-[10px] font-medium leading-none text-center mt-1">{label}</span>
    </>
  );

  const commonProps = {
    className: `${baseClasses} ${activeClasses}`,
    'aria-label': ariaLabel || label,
    'aria-current': active ? 'page' : undefined,
    role: 'tab',
    tabIndex: 0,
  };

  if (to) {
    return (
      <Link 
        to={to} 
        {...commonProps}
        onClick={(e) => {
          // Haptic feedback для мобильных устройств
          if ('vibrate' in navigator) {
            navigator.vibrate(10);
          }
          onClick?.(e);
        }}
      >
        {content}
      </Link>
    );
  }

  return (
    <button 
      {...commonProps}
      onClick={(e) => {
        // Haptic feedback для мобильных устройств
        if ('vibrate' in navigator) {
          navigator.vibrate(10);
        }
        onClick?.(e);
      }}
    >
      {content}
    </button>
  );
};

export default BottomNavItem;